import { createAsyncThunk, createAction, Dispatch } from '@reduxjs/toolkit';

import { removeCookie, deleteAccessToken } from '@backrs_ui/common-ui';

import { PostHog } from 'posthog-js';

import { lifeReadinessApi } from '../lifeReadiness/lifeReadiness.api';
import { onboardingApi } from '../onboarding/onboarding.api';
import { userApi } from '../user/user.api';

/** listen to this one in the store */
export const logout = createAction('auth/logout');

export const resetAllApiStates = (dispatch: Dispatch) => {
  dispatch(userApi.util.resetApiState());
  dispatch(lifeReadinessApi.util.resetApiState());
  dispatch(onboardingApi.util.resetApiState());
};

/** dispatch this thunk from components (the page shell) */
export const logoutThunk = createAsyncThunk(
  'auth/logoutThunk',
  async ({ postHog }: { postHog: PostHog }, { dispatch }) => {
    // first delete the access token
    deleteAccessToken('backrs_ui_token');

    // then remove the cookie
    removeCookie();

    // first dispatch the logout action so all slices can handle it
    dispatch(logout());

    // then reset all createAPI states
    resetAllApiStates(dispatch);

    postHog.capture('logout');
    postHog.reset();
  },
);
